import * as React from "react";
import { SVGProps } from "react";
const SvgDivide = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 22a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM6 15h20c.6 0 1 .4 1 1 0 .557-.345.942-.875.994L26 17H6c-.6 0-1-.4-1-1 0-.557.345-.942.875-.994L6 15Zm10-8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDivide;
